import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import type { LoggedUser } from '@/api/auth/types/LoggedUser'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Spinner } from '@/components/ui/spinner'

import ChangePasswordDialog from './ChangePasswordDialog'

type EditableProfile = {
  name: string
  family_name: string
  email: string
  phone_number: string
}

const toEditable = (user?: LoggedUser): EditableProfile => {
  return {
    name: user?.name ?? '',
    family_name: user?.familyName ?? '',
    email: user?.email ?? '',
    phone_number: user?.phoneNumber ?? '',
  }
}

export default function ProfileEditPage() {
  const { t } = useTranslation()
  const { data: currentUser } = useCurrentUser()
  // const { mutate: updateUser, isPending: isUpdatingUser, isSuccess: isUpdateUserSuccess } = useUpdateUser()

  const initial = useMemo(() => toEditable(currentUser), [currentUser])
  const [form, setForm] = useState<EditableProfile>(initial)
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false)

  useEffect(() => {
    setForm(initial)
  }, [initial])

  // const handleChange = (field: keyof EditableProfile, value: string) => {
  //   setForm(prev => ({ ...prev, [field]: value }))
  // }

  // const handleSubmit = () => {
  //   const payload = {
  //     name: form.name,
  //     family_name: form.family_name,
  //     email: form.email,
  //     phone_number: form.phone_number,
  //   }
  //   updateUser(payload)
  // }
  return (
    <>
      <Card className='bg-white'>
        {currentUser ? (
          <CardContent className='space-y-6'>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
              <div className='space-y-2'>
                <Label htmlFor='name'>{t('profile.firstName')}</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.name}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='family_name'>{t('profile.lastName')}</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.family_name}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='email'>{t('profile.email')}</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.email}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='phone_number'>{t('profile.mobilePhone')}</Label>
                <p dir='ltr' className='text-text-primary text-right text-sm leading-5 font-medium'>
                  {form.phone_number.replace('+972', '')}
                </p>
              </div>
            </div>
            <div className='flex items-center'>
              <Button variant='link' onClick={() => setIsPasswordDialogOpen(true)}>
                {t('profile.changePassword')}
              </Button>
            </div>
            {/* <div className='flex items-center justify-end gap-3'>
            <Button variant='secondary' onClick={() => setForm(initial)} disabled={isUpdatingUser}>
              בטל
            </Button>
            <Button onClick={handleSubmit} disabled={isUpdatingUser}>
              {isUpdatingUser ? t('profile.saveButtonSaving') : isUpdateUserSuccess ? t('profile.saveButtonSaved') : t('profile.saveButton')}
            </Button>
          </div> */}
          </CardContent>
        ) : (
          <Spinner className='mx-auto size-10' />
        )}
      </Card>

      <ChangePasswordDialog isOpen={isPasswordDialogOpen} onOpenChange={setIsPasswordDialogOpen} />
    </>
  )
}
